import { AbstractControl, ValidatorFn } from '@angular/forms';

export function timeFormatValidator(): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    const value = control.value?.trim();

    // Allow empty value (i.e., valid when optional)
    if (!value) {
      return null;
    }

    const valid = /^(\d+[hmd](\s)*)+$/.test(value);
    return valid ? null : { invalidFormat: true };
  };
}